import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { NavigationService } from './navigation.service';
import { AuthUser } from '../models/auth/AuthUser';
import { PermissionsEnum } from '../models/users/roles/enums/permissions';
import { RolesEnum } from '../models/users/roles/enums/roles';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  public currentUserSubject: BehaviorSubject<AuthUser | null> =
    new BehaviorSubject<AuthUser | null>(null);
  public authUser: any;
  storageOtpKey = 'otp-open';

  appEncryptToken = 'scotAngularAppTS';
  encKey = CryptoJS.enc.Utf8.parse(this.appEncryptToken);
  encIv = CryptoJS.enc.Utf8.parse(this.appEncryptToken);

  SignalRConnectionId = new BehaviorSubject<string | null>(null);

  skipLinks = [
    {
      keys: ['/admin/labs'],
      value: '/admin/our-labs',
    }
  ];

  viewsRoles: { [key: string]: (RolesEnum | PermissionsEnum[])[] } = {
    '/admin/all-users': [RolesEnum.SuperAdmin],
    '/admin/users/restaurant-users': [RolesEnum.SuperAdmin],
    '/admin/users/virtual-lab': [RolesEnum.SuperAdmin],
    '/admin/labs': [
      RolesEnum.SuperAdmin,
      RolesEnum.VLAdmin,
      RolesEnum.HospitalAdmin,
      RolesEnum.ClinicAdmin,
    ],
    '/admin/our-labs': [RolesEnum.HospitalAdmin, RolesEnum.ClinicAdmin],
    // '/admin/scanning-centers': [RolesEnum.SuperAdmin],

    '/admin/labProfile': [
      RolesEnum.LabAdmin,
      // RolesEnum.Pathologist,
      RolesEnum.LabTechnician,
      RolesEnum.LabAccountant,
      RolesEnum.LabRepresentative,
      RolesEnum.LabSupervisor,
      RolesEnum.MatchMaker,
      RolesEnum.LabQualityManager,
      RolesEnum.LabTechnologist,
    ],
    '/admin/vlProfile': [
      RolesEnum.SuperAdmin,
      RolesEnum.VLAdmin,
      RolesEnum.VLMatchMaker,
      RolesEnum.VLPathologist,
      RolesEnum.VLSupervisor,
      RolesEnum.VLTechnician,
      RolesEnum.VLRepresentative,
      RolesEnum.VLabQualityManager,
      RolesEnum.VLAccountant,
      RolesEnum.VLabTechnologist,
    ],
    '/admin/users/labStaff': [RolesEnum.LabAdmin],

    '/admin/support-ticket': [
      RolesEnum.LabAdmin,
      RolesEnum.VLAdmin,
      RolesEnum.SuperAdmin,
    ],

    ////////////////////
    '/login': [],
    '/verifiy-otp': [],
    '/admin/myprofile': [],
    '/admin/changepassword': [],
    '/admin/notAuthorized': [],
    '/admin': [],
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private NavService: NavigationService
  ) {
    const authLS = localStorage.getItem('authUser');
    const ls = authLS ? JSON.parse(authLS) as AuthUser : '';
    // console.log(ls)
    if (ls) {
      ls.UserRoles = this.decryptPermissions(ls.UserRoles);
      ls.Permissions = this.decryptPermissions(ls.Permissions || []);
      this.currentUserSubject.next(ls);
      this.AuthUserNavMenu();
    }

    window.addEventListener('storage', () => {
      // When local storage changes, dump the list to
      const authUser = JSON.parse(localStorage.getItem('authUser') ?? '') as AuthUser;
      if (
        (this.currentUserValue &&
          authUser &&
          this.currentUserValue.Token !== authUser.Token) ||
        (this.currentUserValue && !authUser) ||
        (!this.currentUserValue && authUser)
      ) {
        location.reload();
      }
    });
  }

  public get currentUserValue(): AuthUser | null {
    return this.currentUserSubject.value;
  }

  encryptPermissions(permissions: any) {
    const encryptedPermissions: any = [];
    permissions.forEach((element: any) => {
      encryptedPermissions.push(this.encrypt(element));
    });
    return encryptedPermissions;
  }
  decryptPermissions(permissions: any) {
    const decriptedPermissions: any = [];
    if (permissions.length) {
      permissions.forEach((element: any) => {
        if (element) {
          decriptedPermissions.push(this.isEncrypted(element) ? this.decrypt(element) : element);
        }
      });
    }
    return decriptedPermissions;
  }
  encrypt(request: any) {
    return CryptoJS.AES.encrypt(
      request, this.encKey, {
      keySize: 16,
      iv: this.encIv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
  }
  decrypt(data: any) {
    return CryptoJS.AES.decrypt(
      data, this.encKey, {
      keySize: 16,
      iv: this.encIv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
  }

  isEncrypted(data: string): boolean {
    try {
      // Attempt to decrypt the data
      const decrypted = this.decrypt(data).toString();
      // If decryption results in a non-empty string, it's likely encrypted
      return decrypted.trim() !== '';
    } catch (error) {
      // If decryption fails, the data is not encrypted
      return false;
    }
  }


  AuthUserNavMenu(list = null) {
    const authUserMenu = list || [...this.NavService.defaultMenu];
    authUserMenu.map((element: any) => {
      element.canAccess = this.canAccess(element.state);
      const indexFound = this.skipLinks.findIndex(
        (item) => item.value === element.state
      );
      if (indexFound > -1 && element.canAccess) {
        this.skipLinks[indexFound].keys.map((key) => {
          const indexItem = authUserMenu.findIndex(
            (item) => item.state === key
          );
          if (indexItem > -1) {
            authUserMenu.splice(indexItem, 1);
          }
        });
      }
      if (element.sub && element.sub.length) {
        this.AuthUserNavMenu(element.sub);
      }
    });
    this.NavService.menuItems.next(authUserMenu);
  }

  canAccess(link: any, gard = false) {
    let currentKey = '';
    let canAccess = false;
    if (this.currentUserValue) {
      for (const [key, value] of Object.entries(this.viewsRoles)) {
        currentKey = key;
        // if (key == "/admin/trainingCourses" && link == "/admin/trainingCourses/details/390") {
        //   debugger
        // }

        if (!value.length && key === link) {
          canAccess = true;
        } // no role need
        // gard
        let gardPathAccess = false;
        if (gard) {
          gardPathAccess = link && key && link.includes(key) && !(link in this.viewsRoles);
        }
        if (!canAccess && (key === link || gardPathAccess)) {
          // link && key && link.includes(key)
          this.currentUserValue.UserRoles.forEach((role) => {
            // !value || !value.length ||
            if ((value.includes(role)) && !canAccess) {
              if (value.length && value.find((item: any) => Array.isArray(item))) {
                canAccess = (value.find((item: any) => Array.isArray(item)) as any[])?.every((item: any) => this.currentUserValue?.Permissions.includes(item)) ?? false;
              } else {
                canAccess = true;
              }
            }
          });
        }
      }
    }

    return canAccess;
  }

  login(data: any) {
    return this.http
      .post<AuthUser>(`${environment.apiUrl}/Authenticate/login`, data)
      .pipe(
        map((user) => {
          if (user && user.Token) {
            const currentUserValue = { ...user };
            this.currentUserSubject.next(user);
            currentUserValue.UserRoles = this.encryptPermissions(user.UserRoles);
            currentUserValue.Permissions = this.encryptPermissions(user.Permissions);
            localStorage.setItem('authUser', JSON.stringify(currentUserValue));
            this.AuthUserNavMenu();
            return user;
          }
          return false;
        })
      );
  }
  RefeshUserToken(reload = false, reloadRefeshUserToken?: any) {
    return this.http
      .post<AuthUser>(`${environment.apiUrl}/Authenticate/refresh-token`, {})
      .pipe(
        map((returnUser) => {
          if (returnUser) {
            const user = { ...returnUser };
            user.UserRoles = this.encryptPermissions(user.UserRoles);
            user.Permissions = this.encryptPermissions(user.Permissions);
            this.currentUserSubject.next(returnUser);
            localStorage.setItem('authUser', JSON.stringify(user));
            if (this.router.url !== '/admin/myprofile') {
              location.reload();
            } else if (
              (reload && this.router.url !== '/admin/myprofile') ||
              reloadRefeshUserToken
            ) {
              location.reload();
            }
          } else {
            this.logout();
          }
        })
      );
  }
  logout() {
    this.clearUserData();
    this.router.navigate(['/login']).then(() => location.reload());
  }
  clearUserData() {
    localStorage.removeItem('concurelUser');
    localStorage.removeItem('authUser');
    this.currentUserSubject.next(null);
  }
  checkActivationLink(userId: any, token: any) {
    return this.http.post(`${environment.apiUrl}/Authenticate/VerifyToken`, {
      userId,
      token,
    });
  }
  VerifyResetToken(userId: any, token: any) {
    return this.http.post(
      `${environment.apiUrl}/Authenticate/VerifyResetToken`,
      { userId, token }
    );
  }
  changeUserNamePassword(data: any) {
    return this.http.post(
      `${environment.apiUrl}/Authenticate/ChangeUserNamePassword`,
      data
    );
  }
  forget(type: any, value: any): any {
    if (type === 'username') {
      return this.http.post(
        `${environment.apiUrl}/Authenticate/ForgetUserName`,
        { Email: value }
      );
    }
    if (type === 'password') {
      return this.http.get(
        `${environment.apiUrl}/Authenticate/GenerateResetPasswordToken?UserName=${value}`
      );
    }
    return
  }
  resetPassword(userID: any, token: any, password: any) {
    return this.http.post(`${environment.apiUrl}/Authenticate/ResetPassword`, {
      userID,
      token,
      password,
    });
  }

  ChangePassword(oldPassword: any, newPassword: any) {
    return this.http.post(`${environment.apiUrl}/User/ChangePassword`, {
      oldPassword,
      newPassword,
    });
  }
  confrimEmail(userId: any, code: any) {
    return this.http.get(
      `${environment.apiUrl}/User/ConfirmEmail?userId=` +
      userId +
      '&code=' +
      encodeURIComponent(code)
    );
  }
  RegisterUser(obj: any): any {
    return this.http.post(`${environment.apiUrl}/User/RegisterUser`, obj);
  }

  hasPermission(permission: string, checkOtherRoles = false) {
    if (!this.currentUserValue) {
      return false;
    }
    const accessControls: string[] = this.currentUserValue.UserRoles;
    const accessRolesList = permission.split(',');
    const founded = [];
    accessRolesList.forEach((role) => {
      const found = accessControls.some((control) => control === role);
      if (found) {
        founded.push(role);
      }
    });

    // if (founded.length && accessControls.length) { return true; }
    if (
      founded.length &&
      accessControls.length &&
      checkOtherRoles &&
      founded.length !== accessControls.length
    ) {
      return false;
    } else if (founded.length && accessControls.length) {
      return true;
    } else {
      return false;
    }
  }

  hasPermissionPlan(permission: string, checkOtherPermissions = false) {
    if (!this.currentUserValue) {
      return false;
    }
    const accessControls: string[] = this.currentUserValue.Permissions;
    const accessPermissionsList = permission.split(',');
    const founded = [];
    accessPermissionsList.forEach((permission) => {
      const found = accessControls.some((control) => control === permission);
      if (found) {
        founded.push(permission);
      }
    });

    // if (founded.length && accessControls.length) { return true; }
    if (
      founded.length &&
      accessControls.length &&
      checkOtherPermissions &&
      founded.length !== accessControls.length
    ) {
      return false;
    } else if (founded.length && accessControls.length) {
      return true;
    } else {
      return false;
    }
  }

}
